import pack from '../package.json'
const version = pack.version
//@ts-ignore
const viteEnv: string = import.meta.env.VITE_ENV
const isProd = viteEnv === 'production'
const isStage = viteEnv === 'staging'

let whichEnv = 'production'
whichEnv = isProd ? 'production' : isStage ? 'staging' : 'development'

// for overides:
// let whichEnv = 'stage'
// whichEnv = 'live'

const environments: any = {
	production: {
		version: version,
		apiUrl: 'https://api.revotec.at',
		wsUrl: 'https://api.revotec.at',
		wsPath: '/wsio/socket.io',
		// wsUrl: "https://propellercat.com",
		// wsPath: "/revodatawsio/socket.io",
	},
	staging: {
		version: version,
		apiUrl: 'https://propellercat.com/revodata',
		wsUrl: 'https://propellercat.com',
		wsPath: '/revodatawsio/socket.io',
	},
	development: {
		version: version,
		apiUrl: 'http://localhost:8876',
		wsUrl: 'http://localhost:9877',
		wsPath: '/socket.io',
		// apiUrl: "http://192.168.1.102:8876",
		// wsUrl: "http://192.168.1.102:9877",
	},
}
console.log('whichEnv', whichEnv)
export default environments[whichEnv]
